import React from 'react'
import styled from 'styled-components'
import image from '../../images/common/icon/icon-empty.svg'

const Container = styled.div`
  display: flex;
  flex-direction: column;
  height: 234px;
  border-radius: 4px;
  background-color: #fbfbfb;
  justify-content: center;
  align-items: center;
`

const Content = styled.div`
  font-family: 'Noto Sans TC', Helvetica, Arial, 'Helvetica Neue',
      '微軟正黑體', 'Microsoft JhengHei', PMingLiU, sans-serif;
  font-size: 14px;
  font-weight: 500;
  font-style: normal;
  font-stretch: normal;
  line-height: normal;
  letter-spacing: 0.8px;
  text-align: center;
  color: #9b9b9b;
`

const Image = styled.div`
  width: 90px;
  height: 90px;
  margin: 12px;
  background-image: url(${image});
`

const BlankBlock = () => {
  return (
    <Container>
      <Image />
      <Content>成為第一個提問者</Content>
    </Container>
  )
}

export default BlankBlock



// WEBPACK FOOTER //
// ./src/components/LectureComment/BlankBlock.js